// Implements: F-IDN-012, F-UIX-009
/**
 * P2: the outcome card of the recovery pages (v3 `.auth-ok`): the brand, a state icon, the `h1`
 * the container focuses, one paragraph and the actions under it. «Revisa tu correo», «Contraseña
 * actualizada» and «Este enlace ya no sirve» are this card with different content. Pure presentation.
 */

import type { ReactElement, ReactNode, RefObject } from "react";

import type { IconName } from "../../../shared/design-system/icons";
import { Icon } from "../../../shared/ui/atoms/Icon";
import { RecoveryBrand } from "./RecoveryBrand";
import login from "./LoginForm.module.css";
import styles from "./Recovery.module.css";

export interface RecoveryOutcomeProps {
  readonly icon: IconName;
  /** The danger tint of the icon («Este enlace ya no sirve»). */
  readonly failed?: boolean | undefined;
  readonly title: string;
  readonly body: ReactNode;
  readonly actions: ReactNode;
  readonly headingRef: RefObject<HTMLHeadingElement | null>;
}

export function RecoveryOutcome({ icon, failed = false, title, body, actions, headingRef }: RecoveryOutcomeProps): ReactElement {
  return (
    <div className={login.form}>
      <RecoveryBrand />
      <div className={styles.ok}>
        <div className={[styles.stateIcon, failed ? styles.stateIconError : undefined].filter(Boolean).join(" ")}>
          <Icon name={icon} />
        </div>
        <h1 className={login.title} tabIndex={-1} ref={headingRef}>
          {title}
        </h1>
        <p className={login.subtitle}>{body}</p>
      </div>
      {actions}
    </div>
  );
}
